const formatter = (value, type) => {
  if (type === 'currency') {
    return `£${value}`
  }

  if (type === 'years') {
    return parseInt(value, 10) > 1 ? `${value} years` : `${value} year`
  }

  if (type === 'months') {
    return parseInt(value, 10) > 1 ? `${value} months` : `${value} month`
  }
  return value
}

export default formatter
